import {Component, computed, input} from "@angular/core";
import {CameraLayoutOptionsContainer, LiveStreamCameraLayoutOptions, PlaybackCameraLayoutOptions} from "@models";

@Component({
	selector: "sim-screen-container",
	templateUrl: "./screen-container.component.html",
	styleUrls: ["./screen-container.component.scss"],
	standalone: false,
})
export class ScreenContainerComponent {
	public screenIndex = input.required<number>();
	public isSingleView = input<boolean>();
	public cameraLayoutOptionsContainer = input.required<CameraLayoutOptionsContainer>();

	public liveStreamOptions = computed(() => this.cameraLayoutOptionsContainer().options as LiveStreamCameraLayoutOptions);
	public playbackOptions = computed(() => this.cameraLayoutOptionsContainer().options as PlaybackCameraLayoutOptions);

	constructor() {}
}
